module.exports = __webpack_public_path__ + "static/media/belcolor__12.1615b4f0.jpg";